// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityCommonApiClient } from '../../contexts/UtilityCommonApiContext';

export const useGetBackendVersion: () => UseQueryResult<string, string> = () => {
  const commonApi = useUtilityCommonApiClient();

  return useQuery({
    queryKey: ['getBackendVersion', commonApi],
    queryFn: async () => {
      const response = await commonApi.getVersion();
      return response.version;
    },
    refetchInterval: false,
  });
};
